/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type GetApiBookingListSortBy = typeof GetApiBookingListSortBy[keyof typeof GetApiBookingListSortBy] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiBookingListSortBy = {
  id: 'id',
  visibleStatus: 'visibleStatus',
  guest: 'guest',
  unit: 'unit',
  source: 'source',
  startAt: 'startAt',
  endAt: 'endAt',
  bookedAt: 'bookedAt',
  createdAt: 'createdAt',
  bsBookingId: 'bsBookingId',
  ruBookingId: 'ruBookingId',
} as const;
